import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { News } from "../base/news-post/model/news.model";
import { map } from "rxjs/operators";

@Injectable()
export class FileLoaderService {
  constructor(private http: HttpClient) {}

  getNews(): Observable<Array<News>> {
    return this.http.get<Array<News>>("../datas/m-news.json").pipe(
      map((news) => {
        news.forEach((n) => {
          n.endDate = new Date(n.endDate);
          n.date = new Date(n.date);
        });
        return news;
      })
    );
  }

  getDocs(): Observable<Array<any>> {
    return this.http.get<any>("../datas/m-docs.json");
  }

  getNNODocs(): Observable<Array<any>> {
    return this.http.get<any>("../datas/nno-docs.json");
  }

  getHvbDocs(): Observable<Array<any>> {
    return this.http.get<any>("../datas/m-hvb.json");
  }

  getElectionDocs(): Observable<Array<any>> {
    return this.http.get<any>("../datas/m-election.json");
  }
}
